export default __webpack_public_path__ + "static/media/SNAPS.9244aef0.wav";